import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = { url: String };

  copy() {
    navigator.clipboard.writeText(this.urlValue).then(() => {
      this.Copied();
    });
  }

  Copied() {
    const el = this.element.querySelector("span");
    const original = el.innerText;
    el.innerText = "Copied!";
    setTimeout(() => {
      el.innerText = original;
    }, 1200);
  }
}
